import React from "react";

import FredericTechImage from "../../illustrations/Frederic.png";
import MarieBooksLogo from "../../illustrations/Marie-Books.png";

import history from "../../router/history";

//Material-UI
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { Link } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  //About
  aboutRoot: {
    maxWidth: 345,
    margin: "auto",
    marginTop: 16,
  },
  aboutMedia: {
    height: 140,
  },
  aboutContent: {
    minHeight: 200,
  },
}));

export default function About() {
  const classes = useStyles();

  const navigateToPage = (page) => {
    history.push(page);
  };

  return (
    <React.Fragment>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <Card className={classes.aboutRoot}>
            <CardActionArea>
              <CardMedia
                className={classes.aboutMedia}
                image={MarieBooksLogo}
                title="Marie-Books Logo"
              />
              <CardContent className={classes.aboutContent}>
                <Typography gutterBottom variant="h5" component="h2">
                  About
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  Sit back, relax, and enjoy some good reads. Marie-Books gives
                  you the ability to search for any book you like, add it to
                  your reading list, and track you reading progress. Bonus: You
                  may as well Download any book you like.
                </Typography>
              </CardContent>
            </CardActionArea>
            <CardActions>
              <Button color="primary" onClick={() => navigateToPage("/")}>
                Home
              </Button>
            </CardActions>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Card className={classes.aboutRoot}>
            <CardActionArea>
              <CardMedia
                className={classes.aboutMedia}
                image={FredericTechImage}
                title="FredericTech Image"
              />
              <CardContent className={classes.aboutContent}>
                <Typography gutterBottom variant="h5" component="h2">
                  Developer
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  I'm a Web and Android Developer with more than 3 years of
                  experience. I'm currently assuming the role of a Development
                  Team Lead, managing a small team of senior developers. My main
                  expertise is in Azure Cloud Computing, .Net Framework, Google
                  Firebase, and React JS.
                </Typography>
              </CardContent>
            </CardActionArea>
            <CardActions>
              <Button
                color="primary"
                component={Link}
                href="http://frederictech.com"
                target="_blank"
              >
                Github Profile
              </Button>
            </CardActions>
          </Card>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
